module.exports = __webpack_public_path__ + "img/source05_2.e3b57845.png";